import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import { Icon } from '../../../../../../common/html/icon'
import { SelectCustom } from '../../../../../../common/selectCustom'
import { SCROLL_LAYOUT_ELEMENT_ID } from '../../../../../../layout/LayoutContainer'
import { ErrorMessage } from '../../../../common/errorMessage'
import { Input } from '../../../../common/input'
import {
  selectData,
  selectScreeningIndicatorById,
} from '../../../../common/store/slice'
import { changeCriteria, selectCriteria } from '../../../store/slice'
import { DeleteAddButtons } from '../deleteAddButtons'
import classes from './index.module.scss'

const getDataSelector = (dataSource) => {
  switch (dataSource) {
    case 'Status':
      return 'companyStatus'
    case 'LegalForms':
      return 'legalForm'
    case 'CompanyTypes':
      return 'companyType'
    case 'ListingStatus':
      return 'listingStatus'
    default:
      return
  }
}

export const DropdownList = ({ criteriaGroup, screeningIndicatorId }) => {
  const dispatch = useDispatch()

  const dataSource = useSelector(
    selectScreeningIndicatorById(screeningIndicatorId, 'dataSource'),
  )

  const dataList = useSelector(selectData(getDataSelector(dataSource))) || []

  const selectedIds = useSelector(
    selectCriteria([criteriaGroup, screeningIndicatorId, 'data']),
  )
  const selectedItemCount = !selectedIds
    ? 0
    : dataList.filter((i) => selectedIds[i.id] && !selectedIds[i.parentId])
        .length
  const isError = useSelector(
    selectCriteria([criteriaGroup, screeningIndicatorId, 'error']),
  )

  //Set default data if not exist
  useEffect(() => {
    if (!selectedIds) {
      dispatch(
        changeCriteria({
          path: [criteriaGroup, screeningIndicatorId, 'data'],
          data: {},
        }),
      )
    }
  }, [selectedIds])

  const onToggleItem = (item) => {
    if (isError && !selectedIds[item.id]) {
      dispatch(
        changeCriteria({
          path: [criteriaGroup, screeningIndicatorId, 'error'],
          data: undefined,
        }),
      )
    }

    const newSelectedIds = { ...selectedIds }
    const isChecked = selectedIds[item.id]
    const isChild = !!item.parentId

    if (isChild) {
      if (isChecked) {
        newSelectedIds[item.id] = false
        newSelectedIds[item.parentId] = false
      } else {
        newSelectedIds[item.id] = true
        const isAllOtherChildChecked = dataList
          .filter((i) => i.parentId === item.parentId && i.id !== item.id)
          .every((i) => selectedIds[i.id])
        if (isAllOtherChildChecked) {
          newSelectedIds[item.parentId] = true
        }
      }
    } else {
      const childrenIds = dataList
        .filter((i) => i.parentId === item.id)
        .map((i) => i.id)

      newSelectedIds[item.id] = !isChecked
      childrenIds.forEach((id) => {
        newSelectedIds[id] = !isChecked
      })
    }

    dispatch(
      changeCriteria({
        path: [criteriaGroup, screeningIndicatorId, 'data'],
        data: newSelectedIds,
      }),
    )
  }

  const handleDeleteBtnClick = (item) => {
    const newSelectedIds = { ...selectedIds }
    const isChild = !!item.parentId

    if (isChild) {
      newSelectedIds[item.id] = false
      newSelectedIds[item.parentId] = false
    } else {
      const childrenIds = dataList
        .filter((i) => i.parentId === item.id)
        .map((i) => i.id)
      newSelectedIds[item.id] = false
      childrenIds.forEach((id) => {
        newSelectedIds[id] = false
      })
    }

    dispatch(
      changeCriteria({
        path: [criteriaGroup, screeningIndicatorId, 'data'],
        data: newSelectedIds,
      }),
    )
  }

  const renderActiveItem = () => (
    <Element elementName="span">
      {!selectedItemCount ? (
        <Translate value="screening.SELECT_ITEMS" />
      ) : (
        <Translate
          value="screening.NUMBER_ITEM_SELECTED"
          count={selectedItemCount}
          suffix={selectedItemCount > 1 ? 's' : ''}
        />
      )}
    </Element>
  )

  const renderDropdownItem = (item) => {
    const isCheck = selectedIds[item.id]
    return (
      <Element
        elementName="li"
        style={{ borderColor: '#D5D5D5', paddingLeft: item.parentId ? 24 : 0 }}
        className={classes.dropdownListItem}
        onClick={() => onToggleItem(item)}
      >
        <Icon
          className={isCheck ? 'icon-checkbox-check' : 'icon-checkbox-uncheck'}
          style={{
            fontSize: 15,
            color: isCheck ? '#2C73E8' : '#9C9C9C',
          }}
        />
        <Element elementName="span">{item.name}</Element>
      </Element>
    )
  }

  const renderSelectedItems = () => {
    if (!selectedIds) return null

    return dataList.map((item) => {
      if (selectedIds[item.id] && !selectedIds[item.parentId]) {
        return (
          <Element key={item.id} className={`dFlex ${classes.mt4}`}>
            <Input
              key={item.id}
              value={item.name}
              disabled
              readOnly
              wrapperClassname="flex1 minW0"
            />
            <DeleteAddButtons
              onDeleteBtnClick={() => handleDeleteBtnClick(item)}
            />
          </Element>
        )
      }
      return null
    })
  }

  if (!dataList || dataList.length === 0 || !selectedIds) return null

  return (
    <Element className={classes.pb4}>
      <SelectCustom
        data={dataList}
        renderActiveItem={renderActiveItem}
        renderDropdownItem={renderDropdownItem}
        style={{ fontSize: 12 }}
        className={classes.select}
        maxItem={12}
        scrollElementIds={['MainContent', SCROLL_LAYOUT_ELEMENT_ID]}
      />
      {renderSelectedItems()}
      {isError && <ErrorMessage value="screening.REQUIRED_MESS" />}
    </Element>
  )
}
